import type { AdminLatestFailure, AdminUserDataRiskItem } from "../../contracts/admin-read-models";
import type { AdminDashboardLocale } from "./admin-dashboard-locale";
import { pickAdminDashboardLocaleText } from "./admin-dashboard-copy";

function text(locale: AdminDashboardLocale, en: string, ko: string): string {
  return pickAdminDashboardLocaleText(locale, { en, ko });
}

function formatPetFlowFailureLabel(
  latestPetFailure: AdminLatestFailure | undefined,
  locale: AdminDashboardLocale,
): string {
  switch (latestPetFailure?.stage) {
    case "pet_create":
      return text(locale, "Pet create failed recently", "최근 펫 등록이 실패했습니다");
    case "pet_update":
      return text(locale, "Pet profile update failed recently", "최근 펫 프로필 수정이 실패했습니다");
    case "pet_delete":
      return text(locale, "Pet delete failed recently", "최근 펫 삭제가 실패했습니다");
    case "pet_photo_confirm":
      return text(locale, "Pet photo confirm failed recently", "최근 펫 사진 확정이 실패했습니다");
    default:
      return text(locale, "Pet flow failed recently", "최근 펫 흐름이 실패했습니다");
  }
}

export function formatAdminUserRiskItemLabel(
  item: AdminUserDataRiskItem,
  locale: AdminDashboardLocale,
  latestPetFailure?: AdminLatestFailure,
): string {
  switch (item.code) {
    case "AI_JOB_FAILED":
      return text(locale, "AI job failed", "AI 작업이 실패했습니다");
    case "FILE_CLEANUP_FAILED":
      return text(locale, "File cleanup failed", "파일 정리가 실패했습니다");
    case "FILE_CLEANUP_PENDING":
      return text(locale, "Deleted file is waiting for storage cleanup", "삭제된 파일이 스토리지 정리를 기다리고 있습니다");
    case "FILE_CONFIRMED_LINK_MISSING":
      return text(locale, "Confirmed file is missing a linked entity", "확정된 파일에 연결 대상이 없습니다");
    case "FILE_TEMP_EXPIRED":
      return text(locale, "Temporary file expired before confirmation", "임시 파일이 확정 전에 만료되었습니다");
    case "ACCOUNT_DELETION_FAILED":
      return text(locale, "Account deletion failed", "계정 삭제가 실패했습니다");
    case "PET_PROFILE_MISSING_REQUIRED":
      return text(locale, "Pet profile missing required fields", "펫 프로필에 필수 항목이 누락되었습니다");
    case "PET_PHOTO_LINK_MISSING":
      return text(locale, "Pet photo link missing", "펫 사진 연결이 누락되었습니다");
    case "PET_FLOW_FAILED":
      return formatPetFlowFailureLabel(latestPetFailure, locale);
    default:
      return item.label;
  }
}

export function localizeAdminUserRiskItems(
  items: readonly AdminUserDataRiskItem[],
  locale: AdminDashboardLocale,
  latestPetFailure?: AdminLatestFailure,
): AdminUserDataRiskItem[] {
  return items.map((item) => ({
    ...item,
    label: formatAdminUserRiskItemLabel(item, locale, latestPetFailure),
  }));
}
